import {
  CheckoutRequest,
  RemoteResult,
  CheckoutOrder,
  LoadState,
} from "mangdto"
import BaseLogic from "../base_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"

export default class BezahlungWeiterleitenBestellungLogic extends BaseLogic {
  weiterleitenLoadState: LoadState = LoadState.Idle

  init(id: string) {
    this.weiterleitenLoadState = LoadState.Loading

    var request = new CheckoutRequest()
    request.id = id

    Poster.postUser<RemoteResult<CheckoutOrder>>(
      RestPaths.paymentPaypalCheckout,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.weiterleitenLoadState = LoadState.Completed
          window.location.href =
            "https://www.sandbox.paypal.com/checkoutnow?token=" +
            response.data.payload.orderId
        } else {
          this.weiterleitenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.weiterleitenLoadState = LoadState.Error
      })
  }
}
